import { useQuery } from '@tanstack/react-query'

import { getDailyMissionApi, getDailyMissionDateRangeApi } from '@/api/dailyMissionApi'
import type { DailyMissionDateRangeParams } from '@/api/model/dailyMissionType'

export const useGetDailyMissionQuery = (target_date: string) => {
  return useQuery({
    queryKey: ['dailyMission', target_date],
    queryFn: () => getDailyMissionApi(target_date)
  })
}

export const useGetDailyMissionDateRangeQuery = (params: DailyMissionDateRangeParams) => {
  return useQuery({
    queryKey: ['dailyMissionDateRange', params],
    queryFn: () => getDailyMissionDateRangeApi(params)
  })
}
